import { Button } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { FormField, FormFieldType, DownloadExcel } from "@components";
import { i18, trb } from "@utilities";

import "./TableFilters.less";

export const CountriesSettingsTableFilter = ({
  onFilter,
  filterValues,
  isDownloadingExcel,
  handleDownload
}) => {
  return (
    <div className="config-settings-filter-container">
      <Form
        onSubmit={onFilter}
        render={({ handleSubmit }) => {
          return (
            <form className="my-3" onSubmit={handleSubmit}>
              <div className="d-flex align-items-center input-container">
                <div>
                  <FormField
                    name="iso2"
                    component={FormFieldType.input}
                    title={i18.ApplicationsLabels.iso2FilterInput}
                    size="large"
                    defaultValue={filterValues.iso2}
                  />
                </div>
                <div className="align-self-center">
                  <FormField
                    name="isActual"
                    component={FormFieldType.checkbox}
                    inline={true}
                    defaultValue={filterValues.isActual}
                    label={trb(i18.ApplicationsLabels.isActualFilterInput)}
                  />
                </div>
                <div className="d-flex align-items-end button-container">
                  <Button htmlType="submit" type="primary">
                    {trb(i18.Buttons.Filter)}
                  </Button>
                  <DownloadExcel isLoading={isDownloadingExcel} handleDownload={handleDownload} />
                </div>
              </div>
            </form>
          );
        }}
      />
    </div>
  );
};
